import React from "react";
import { types } from "./config";

import DynamicInput from "components/DynamicInput/DynamicInput";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";

import { makeStyles } from "@material-ui/core/styles";
import { styles, CheckboxWrapper } from "../ModalConfig/styles";
import { BLUE_RGB } from "utils/colorsTheme";

// @material-ui/icons
import Check from "@material-ui/icons/Check";

const useStyles = makeStyles(styles);

const CheckBoxItem = ({ row, unit, onChangeRow }) => {
  const classes = useStyles();
  return (
    <CheckboxWrapper>
      <InputLabel className={classes.marginLabel}>
        {row ? row.name : "Titulo"}
      </InputLabel>
      <Checkbox
        checkedIcon={<Check className={`${classes.checkedIconCustom}`} />}
        icon={<Check className={classes.uncheckedIconCustom} />}
        checked={Boolean(unit.conf[row.property])}
        onChange={() =>
          onChangeRow(row.property, !Boolean(unit.conf[row.property]))
        }
        style={{
          color: BLUE_RGB,
        }}
        classes={{
          checked: classes.checked,
          root: classes.checkRoot,
        }}
      />
    </CheckboxWrapper>
  );
};
const InputItem = ({ row, unit, onChangeRow }) => {
  const classes = useStyles();
  return (
    <CheckboxWrapper>
      <InputLabel
        // htmlFor="simple-select"
        className={classes.marginLabel}
      >
        {row ? row.name : "Titulo"}
      </InputLabel>
      <DynamicInput
        id="material"
        color="info"
        formControlProps={{
          fullWidth: true,
        }}
        inputProps={{
          value: String(unit.conf[row.property]),
          type: "number",
          onChange: (event) => onChangeRow(row.property, event.target.value),
          color: "secondary",
        }}
      />
    </CheckboxWrapper>
  );
};

export const ConfigUnitGroup = ({ config, row, unit, onChangeRow }) => {
  switch (config) {
    case types.check:
      return (
        unit && <CheckBoxItem row={row} unit={unit} onChangeRow={onChangeRow} />
      );
    case types.integer:
      return (
        unit && <InputItem row={row} unit={unit} onChangeRow={onChangeRow} />
      );
    case types.float:
      return (
        unit && <InputItem row={row} unit={unit} onChangeRow={onChangeRow} />
      );
    default:
      return <></>;
  }
};
